import CaseUpdateView from './CaseUpdateView'

export default CaseUpdateView
